export default "__VITE_ASSET__7dd9b2fe__"